import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from 'utils';
import { JobFormValues } from './create-job-stages/job-details/types';

export const createJobStart = createAction(
  'CREATE_JOB::START',
  withPayloadType<{ jobInfo: JobFormValues; organizationId: string }>(),
);
